import React from 'react'

const AestheticsLightbox = () => {
  return (
    <div className='lightbox__paragraph'>
    <h1>Available Services</h1>
    <br />
    <ul>
        <li>• Pharmaceutical-Grade Skincare</li>
        <li>• Medical Facials</li>
        <li>• Hydrafacials</li>
        <li>• Chemical Peels</li>
        <li>• Latisse&#174; Eyelash Enhancements</li>
    </ul>
    </div>
  )
}

export default AestheticsLightbox
